/*
 * @Author: wangshengqiang
 * @Date: 2021-05-19 10:56:35
 * @LastEditTime: 2021-05-24 18:42:14
 * @LastEditors: wangshengqiang
 * @Description: 利益演示表格
 */
import React, { useEffect, useState, useContext } from 'react';
import { ModuleContext } from '../BaseModule';
import './index.less';

const BenefitDemonstrationTable = (props = {}) => {
  const {
    attrs
  } = props;
  const {
    benefitTable
  } = useContext(ModuleContext);
  const {
    datas = [],
    titles = []
  } = benefitTable || {};
  if (!datas || !titles) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "table_wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table_scroll"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, titles === null || titles === void 0 ? void 0 : titles.map((item, index) => {
    return /*#__PURE__*/React.createElement("th", {
      key: index
    }, item, " ");
  }))), /*#__PURE__*/React.createElement("tbody", null, datas === null || datas === void 0 ? void 0 : datas.map((colItem, i) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: i
    }, colItem.map((ele, k) => {
      return /*#__PURE__*/React.createElement("td", {
        key: k
      }, ele);
    }));
  })))));
};

export default BenefitDemonstrationTable;